module.exports = __webpack_public_path__ + "img/3.66973ed6.png";